<form (click)="debugForm(constructor.name)" (keydown)="(null)" class="app-flex-form">
  <div class="form-wrapper form-columns-2">
    @if (showMode() === 'all' || showMode() === 'names') {
      <div class="field-wrapper flex gap-6">
        <mat-form-field class="w-full">
          <mat-label>Prénom</mat-label>
          <input
            [formField]="formTree.firstName"
            (keydown)="onNameKeyDown($event)"
            (paste)="onNamePaste($event, 'firstName')"
            matInput
          />
          <mat-icon
            matTooltip="Caractères autorisés : lettres, accents et tirets pour les prénoms composés (ex. Jean-Paul)."
            >info</mat-icon
          >
          @if (formTree.firstName().errors().length) {
            <mat-error>
              {{
                formTree.firstName().errors()[0].message ||
                  'Veuillez renseigner un prénom valide entre 2 et 30 caractères.'
              }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full">
          <mat-label>Nom</mat-label>
          <input
            [formField]="formTree.lastName"
            (keydown)="onNameKeyDown($event)"
            (paste)="onNamePaste($event, 'lastName')"
            matInput
          />
          <mat-icon
            matTooltip="Caractères autorisés : lettres, accents, apostrophes et tirets (ex. Dupont-Moretti, D'Ormesson)."
            >info</mat-icon
          >
          @if (formTree.lastName().errors().length) {
            <mat-error>
              {{
                formTree.lastName().errors()[0].message ||
                  'Veuillez renseigner un nom valide entre 2 et 30 caractères.'
              }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
    @if (showMode() === 'all' || showMode() === 'demographics') {
      <div class="field-wrapper">
        <mat-form-field>
          <mat-label>Sexe</mat-label>
          <mat-select [panelClass]="allReadonly() ? 'hidden' : ''" [formField]="formTree.gender">
            @for (gender of allGenders; track $index) {
              <mat-option [value]="gender">
                {{ gender | genderDisplay | titlecase }}
              </mat-option>
            }
          </mat-select>
          <mat-error>Sexe obligatoire</mat-error>
        </mat-form-field>
      </div>
      <div class="field-wrapper">
        <mat-form-field>
          <mat-label>Date de naissance</mat-label>
          <input
            [matDatepicker]="picker"
            [formField]="formTree.birthDate"
            (focus)="allReadonly()"
            (click)="allReadonly() && $event.preventDefault()"
            matInput
          />
          <mat-datepicker-toggle [for]="picker" [disabled]="allReadonly()" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error>Date de naissance invalide</mat-error>
        </mat-form-field>
      </div>
    }
  </div>
</form>
